import React from "react";
import { useWatch } from "react-hook-form";
import LargeDropzone from "../../../common/components/LargeDropzone";

const AdditionalFiles = ({ control, name, onDrop }) => {
  const currentFiles = useWatch({ control, name });

  return (
    <LargeDropzone label="Additional Files" onDrop={onDrop} current={currentFiles}/>
  );
};

export default AdditionalFiles;
